module.exports = __webpack_public_path__ + "img/title.00566e49.png";